module.exports = __webpack_public_path__ + "img/1_Moderation Andrea und Christoph.754c7a0c.jpg";